<template>
    <div id="addDeivce" v-loading="isLoging">
        <el-dialog title="添加设备" width="40%" top="2rem" :close-on-click-modal="false" :visible.sync="showDialog" :destroy-on-close="true" @close="close()">
            <div id="shared" style="margin-top: 1rem; margin-right: 100px">
                <el-form ref="addDeivce" :rules="rules" :model="deviceParam" label-width="140px">
                    <el-form-item label="设备名称" prop="deviceName">
                        <el-input v-model="deviceParam.deviceName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="国标编码" prop="deviceGbCode">
                        <el-input v-model="deviceParam.deviceGbCode" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户名" prop="sipUsername">
                        <el-input v-model="deviceParam.sipUsername" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="deviceParam.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="IP地址" prop="lanIp">
                        <el-input v-model="deviceParam.lanIp" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="设备厂家" prop="manufacturer">
                        <el-select size="large" v-model="deviceParam.manufacturer" placeholder="请选择">
                            <el-option key="bocon" label="博控" value="bocon"></el-option>
                            <el-option key="huawei" label="华为" value="huawei"></el-option>
                            <el-option key="haikang" label="海康" value="haikang"></el-option>
                            <el-option key="dahua" label="大华" value="dahua"></el-option>
                        </el-select>

                        <!-- <el-input v-model="deviceParam.manufacturer" clearable></el-input> -->
                    </el-form-item>

                    <el-form-item>
                        <div style="float: right">
                            <el-button type="primary" @click="onSubmit">保存</el-button>
                            <el-button @click="close">取消</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isValidIp } from "@/utils/validate.js";

export default {
  deviceName: "device",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      deviceParam: {
          deviceName: "海康",
          deviceGbCode: "44030200491180000159",
          sipUsername: "44030200491180000159",
          password: "bc123456",
          lanIp: "192.168.31.20",
          manufacturer: "haikang",
      },
      rules: {
          deviceName: [
              {
                  required: true,
                  message: "请输入设备名称",
                  trigger: "blur",
              },
          ],
          deviceGBCode: [
              {
                  required: true,
                  message: "请输入国标编码",
                  trigger: "blur",
              },
          ],
          username: [
              {
                  required: true,
                  message: "请输入设备用户名",
                  trigger: "blur",
              },
          ],
          password: [
              {
                  required: true,
                  message: "请输入设备密码",
                  trigger: "blur",
              },
          ],
          ip: [
              {
                  required: true,
                  validator: isValidIp,
                  message: "请输入有效的IP地址",
                  trigger: "blur",
              },
          ],
      },
    };
  },
  methods: {
      openDialog: function (callback) {
          this.showDialog = true;
          this.listChangeCallback = callback;
      },
      onSubmit: function () {
          console.log("onSubmit");
          var that = this;
          this.$refs.addDeivce.validate((valid) => {
              if (valid) {
                  let post_js = {
                    deviceParam: that.deviceParam,
                  };
                  that.$axios({
                    method: "post",
                    url: `/api/sip/register`,
                    data: post_js,
                    params: {
                      token: this.$cookies.get("session").token,
                    }
                  }).then(function (res) {
                          if (res.data.code == 0) {
                              that.$message({
                                  showClose: true,
                                  message: "保存成功",
                                  type: "success",
                              });
                              that.showDialog = false;
                              if (that.listChangeCallback != null) {
                                  that.listChangeCallback();
                              }
                          } else {
                              that.$message.error(that.data.msg);
                          }
                      })
                      .catch(function (error) {
                          console.log(error);
                      });
              } else {
                  console.log("error submit!!");
                  return false;
              }
          });
      },
      close: function () {
          console.log("关闭创建窗口");
          this.showDialog = false;
      },
      deviceGBIdExit: async function (deviceGbId) {
          var result = false;
          var that = this;
          await that
              .$axios({
                  method: "post",
                  url: `/api/platform/exit/${deviceGbId}`,
              })
              .then(function (res) {
                  result = res.data;
              })
              .catch(function (error) {
                  console.log(error);
              });
          return result;
      },
      checkExpires: function () {
          if (this.platform.enable && this.platform.expires == "0") {
              this.platform.expires = "300";
          }
      },
  },
};
</script>

<style>
.el-form-item__label {
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/addDeviceDlg.vue